export const CATEGORY_OPTIONS = [
  "Electronics",
  "Fashion",
  "Home & Livings",
  "Health & Beauty",
  "Sports & Outdoor",
  "Others",
];
